import React, { useCallback } from 'react';

import { useContentRenderIdentifier } from '@/hooks/useContentRenderIdentifier';
import { upgradeSalesByPaymentType } from '@/lib/productRules';
import useProductStore, { type PaymentType } from '@/stores/productStore';

import AnswerBlock from '../chat/AnswerBlock';

export default function BillingModel() {
  const [resetTrigger, setResetTrigger] = React.useState<boolean | undefined>(undefined);
  const { payment, setFields } = useProductStore(d => ({
    payment: d.payment,
    setFields: d.setFields
  }));

  const handleSelectBillingModel = (value: string[]) => {
    const currentValue = value[0] as PaymentType;

    const newPayment = {
      ...payment,
      type: currentValue as any
    };

    setFields({
      payment: newPayment,
      upgradeSales: upgradeSalesByPaymentType[currentValue]
    });

    setResetTrigger(undefined);
  };

  const onRenderAgain = useCallback(() => {
    setResetTrigger(true);
  }, []);

  useContentRenderIdentifier({
    content: 'billing_model_product',
    onGoBackRender: onRenderAgain
  });

  const options = [
    {
      content: {
        title: 'Oferta única',
        description: 'Venda direta com flexibilidade para o cliente pagar à vista ou parcelado.'
      },
      value: 'oneTime'
    },
    // {
    //   content: {
    //     title: 'Assinatura',
    //     description: 'Receba de forma previsível com cobranças automáticas na periodicidade que você definir.'
    //   },
    //   value: 'subscription'
    // },
    {
      content: {
        title: 'Valor aberto',
        description: 'O cliente escolhe quanto pagar. Ideal para ações de engajamento.'
      },
      value: 'open'
    },
    {
      content: {
        title: 'Gratuito',
        description: 'O cliente recebe o produto sem custo. É uma ótima estratégia para captar leads.'
      },
      value: 'free',
      skip: 2
    }
  ];

  return <AnswerBlock options={options} onSelectOption={handleSelectBillingModel} resetTrigger={resetTrigger} />;
}
